import { useCallback, useState } from "react";
import { fetchAddableUsersForGroup } from "../../service/UserService";
import { fetchEnrolledItems } from "../../service/UserService";


export const useAddableUsers = (groupId) => {
  const [userList, setUserList] = useState([]);
  const [error, setError] = useState(null);

  const fetchAddableUsers = useCallback(async () => {
    const result = await fetchAddableUsersForGroup(groupId);

    if (result?.success) {
      const users = result.data.map((user) => ({
        value: user.userId,
        label: `${user.firstName} ${user.lastName}`,
      }));
      setUserList(users);
      setError(null);
    } else {
      console.error("Failed to fetch addable users:", result?.data);
      setUserList([]);
      setError(result?.data);
    }
  }, [groupId]); 

  return {
    userList,
    error,
    fetchAddableUsers,
  };
};

export const useEnrolledItems = (groupId) => {
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [enrolledBundles, setEnrolledBundles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchEnrolledItemsData = useCallback(async () => {
    if (!groupId) return;

    setIsLoading(true);
    setError(null);

    try {
      const result = await fetchEnrolledItems(groupId);

      if (result?.status === "SUCCESS") {
        setEnrolledCourses(result.data?.courses || []);
        setEnrolledBundles(result.data?.bundles || []);
      } else {
        setError(result?.message || "Failed to fetch items");
      }
    } catch (err) {
      console.error("Failed to fetch enrolled items:", err);
      setError(err.message || "An unexpected error occurred");
    } finally {
      setIsLoading(false);
    }
  }, [groupId]);

  return {
    enrolledCourses,
    enrolledBundles,
    isLoading,
    error,
    fetchEnrolledItems: fetchEnrolledItemsData,
  };
};